import React, { useState } from 'react'
import PropTypes from 'prop-types'
import {
  ListItem,
  ListItemIcon,
  ListItemText,
  Popover,
} from '@material-ui/core'
import { SketchPicker } from 'react-color'
import ThemeEditorColorBubble from './ThemeEditorColorBubble'

const ThemeEditorColorList = props => {
  const { onChange, value, name, label } = props
  const [anchorEl, setAnchorEl] = useState(null)

  const handleChange = color => {
    const rgba = `rgba(${color.rgb.r}, ${color.rgb.g}, ${color.rgb.b}, ${color.rgb.a})`
    onChange(name, rgba)
  }

  const handleClick = event => {
    setAnchorEl(event.currentTarget)
  }

  const handleClose = () => {
    setAnchorEl(null)
  }

  const open = Boolean(anchorEl)

  return (
    <>
      <ListItem button onClick={handleClick} aria-describedby={name}>
        <ListItemIcon>
          <ThemeEditorColorBubble color={value} size={10} />
        </ListItemIcon>
        <ListItemText primary={label} />
      </ListItem>
      <Popover
        id={name}
        anchorEl={anchorEl}
        anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}
        onClose={handleClose}
        open={open}
      >
        <SketchPicker
          color={value}
          onChangeComplete={handleChange}
          hexInputDebounce={750}
          presetColors={[
            '#1565C0',
            '#2196F3',
            '#ed1b42',
            '#be1622',
            '#d32123',
            '#fecf00',
            '#FC0',
            '#14805E',
            '#008542',
            '#ff7800',
            '#1C75BC',
            '#ffffff',
          ]}
        />
      </Popover>
    </>
  )
}

ThemeEditorColorList.propTypes = {
  onChange: PropTypes.func,
  label: PropTypes.string,
  name: PropTypes.string,
  value: PropTypes.string,
}

export default ThemeEditorColorList
